"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaddingContainer = exports.Container = exports.BackOption = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3;

var BackOption = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 14px;\n"])), _palette.palette.link);

exports.BackOption = BackOption;
BackOption.displayName = 'BackOption';

var Container = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items: center;\n  background : ", ";\n  bottom     : 0;\n  display    : flex;\n  height     : ", "px;\n  left       : 0;\n  position   : fixed;\n  width      : 100%;\n  z-index    : 2;\n\n  button {\n    margin: 0;\n  }\n\n  &:before {\n    background-image: linear-gradient(to left, ", ", ", ");\n    content         : \"\";\n    height          : 1px;\n    position        : absolute;\n    top             : 0;\n    width           : 100%;\n  }\n\n  ", " {\n    display: none;\n  }\n"])), _palette.palette.white, _widths.widths.base * 10, _palette.palette.primary, _palette.palette.primaryTransparent, _widths.mediaQueries.desktop);

exports.Container = Container;
Container.displayName = 'Container';

var PaddingContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 0 ", "px;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n"])), _widths.widths.base * 2);

exports.PaddingContainer = PaddingContainer;